import Navbar from "../../../components/Navbar/Navbar";
import RemarksCodesList from "../components/RemarkCodesList/RemarkCodesList";

export default function RemarkCodes() {
    return (
        <>
            <Navbar title="Remark Codes" />
            <div className="page">
                <RemarksCodesList />
            </div>
        </>
    );
}
